import filesaver from 'file-saver'

export default filesaver